import React from "react";
import PageHeader from "../../PageHeader";
import AddGenerateRegistrationLinkForm from "./AddGenerateRegistrationLinkForm";
import { ReactComponent as RegistrationLinkIcon } from "../../../images/registrationlinkimage/registrationlinkimage.svg";
import { ReactComponent as BackIcon } from "../../../images/pageheadingicon/backicon.svg";
import useStyles from "../../../../styles";



function AddGenerateRegistrationLink() {
  const classes = useStyles();




  const Heading = [
    {
      id: 1,
      pageicon: <RegistrationLinkIcon />,
      mainheading: "Generate Registration Link",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/registrationlink",
    },
  ];
  return (
    <div className={`${classes.p2} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <AddGenerateRegistrationLinkForm />
    </div>
  );
}
export default AddGenerateRegistrationLink;
